import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <ol>

<p>The information on LULC over a temporal scale has aided in understanding the landscape composition and configuration of the Gadag district. The built-up area increased from 2 to 65 km<sup>2</sup> at the cost of a forest cover loss of 16 km<sup>2</sup> from 1989 to 2019. LULC information is a base to model possible changes over geographic space and to observe the growth in built-up cover and loss in agriculture and forest area. Landscape metrics accounted for landscape patterns and the influence of patch adjacency. Ecologically susceptible regions in the Gadag district were assessed through composite metrics by integrating bio, geo, hydro, climatic, and ecological factors paired with social aspects. These were compiled at the micro-level through a grid-based NES for representative grids and through an extensive literature review for district-level information. The delineation of ESZ reveals ESZ1 and ESZ2 as the highly sensitive zones where largescale development activity should not be permitted. ESZ1 and ESZ2 fall within the Kappata Gudda range and Naragund and Gajendragad region. Mining activity is reported in the Kappata Gudda range. The grid-wise analysis shows that ESZ1 covers nine grids (16%), ESZ2 covers 31 grids (54%), ESZ3 13 grids (23%), and ESZ4 covers four grids (7%) in the study area. The community-engaged conservation approach, where local communities are involved in decision-making, will aid in the conservation of biological diversity and nourishment of natural resources. The identification of ESZ will assist in shaping effective policies to achieve the sustainable development goals through pattern analysis and all possible dimensions from various interdisciplinary themes.</p>
<p><strong>Acknowledgments</strong></p>
<p>The Karnataka Forest Department is acknowledged for granting permission to undertake ecological research.</p>

</ol>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
